// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".zt__table[data-v-4faaa739] {\n  height: 100%;\n  width: 100%;\n}\n.zt__table[data-v-4faaa739] .el-table {\n  height: 100%;\n}\n.zt__table[data-v-4faaa739] .el-table .el-table__body-wrapper {\n  height: calc(100% - 48px);\n  overflow: auto;\n}\n.zt__table[data-v-4faaa739] .el-pagination {\n  padding: 10px 0 0 0;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
